import React, { memo } from 'react'
import BigPlayIcon from '../../assets/icons/BigPlayIcon'
import { ChevronArrowRightIcon } from '../../assets/icons/ChevronArrowRightIcon'
import './InformativoAssembleiasComVideo.scss'
const rootClassName = 'informativo-assembleias-com-video'

interface InformativoAssembleiasComVideoProps {
  onClick?: () => void
  title?: string
  subtitle?: string
  imgUrl?: string
}

function InformativoAssembleiasComVideo(
  props: InformativoAssembleiasComVideoProps
) {
  return (
    <div className={rootClassName} onClick={props.onClick}>
      <div className={`${rootClassName}-first-row`}>
        <div
          className={`${rootClassName}-thumbnail`}
          style={{ backgroundImage: `url(${props.imgUrl})` }}
        />
        <div className={`${rootClassName}-play-icon`}>
          <BigPlayIcon />
        </div>
      </div>
      <div className={`${rootClassName}-saiba-mais-row`}>
        <div className={`${rootClassName}-icon`}>
          <ChevronArrowRightIcon />
        </div>
      </div>
      <div className={`${rootClassName}-title`}>{props.title}</div>
      <div className={`${rootClassName}-sub-title nunito`}>
        {props.subtitle}
      </div>
    </div>
  )
}

export default memo(InformativoAssembleiasComVideo)
